<template>
  <div class="serviceInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="environment" theme="filled" />
          <span>公网 IP台账</span>
        </a-space>
      </template>
      <span>公网 IP台账包含云服务商、云主机区域等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']"
        :search-type-options="[
          { label: '云服务商', value: 'vendor' },
          { label: '云主机区域', value: 'location' },
          { label: '业务系统名称', value: 'service' },
          { label: '网站域名', value: 'domain' },
          { label: '公网 IP', value: 'ip_address' }
        ]"
        :refresh="refresh"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <!-- <template #service="{ slotProps }">
          <a-tooltip v-if="slotProps.text?.department" placement="topLeft" :title="slotProps.text.department">
            {{ slotProps.text.department }}
          </a-tooltip>
          <span v-else>{{ slotProps.text }}</span>
        </template> -->

        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getPublicIpInventoryList,
  deletePublicIpInventory,
  exportPublicIpInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'PublicIpInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getPublicIpInventoryList,
      exportFunc: exportPublicIpInventory,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'vendor',
          title: '云服务商',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'vendor'
          }
        },
        {
          dataIndex: 'location',
          title: '云主机区域',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'location'
          }
        },
        {
          dataIndex: 'service.name',
          title: '业务系统名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service'
          }
        },
        {
          dataIndex: 'approved_at',
          title: '审核通过日期',
          width: 180,
          scopedSlots: {
            customRender: 'approvedAt'
          }
        },
        {
          dataIndex: 'organization',
          title: '主办单位名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organization'
          }
        },
        {
          dataIndex: 'organization_type',
          title: '主办单位性质',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organizationType'
          }
        },
        {
          dataIndex: 'icp_number',
          title: 'ICP 备案/许可证号',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'icpNumber'
          }
        },
        {
          dataIndex: 'domain',
          title: '网站域名',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'domain'
          }
        },
        {
          dataIndex: 'ip_address',
          title: '公网 IP',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'ipAddress'
          }
        }
      ],
      columnDefaultSelected: [
        'vendor',
        'location',
        'service.name',
        'organization',
        'icp_number',
        'domain',
        'ip_address'
      ]
    }
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deletePublicIpInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    }
  }
}
</script>
